/* loaded by smart-asset */
export default require("./40~rqitCNmH.svg")